import { type ComponentType, type ReactNode } from 'react'
import { Inbox } from 'lucide-react'
import { Button } from '@/components/ui/button'

/**
 * Designed empty state — every list must say *how to get the first row*
 * (UI-RECOMMENDATIONS §5.6), e.g. "No webhooks yet — add an endpoint to
 * receive subscription events."
 */
export interface EmptyStateProps {
  icon?: ComponentType<{ className?: string }>
  title: string
  description?: string
  action?: {
    label: string
    onClick: () => void
  }
  children?: ReactNode
}

export function EmptyState({
  icon: Icon = Inbox,
  title,
  description,
  action,
  children,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-6 py-14 text-center">
      <div className="flex size-11 items-center justify-center rounded-xl bg-surface-sunken">
        <Icon className="size-5 text-content-muted" aria-hidden />
      </div>
      <p className="mt-1 text-sm font-semibold text-content">{title}</p>
      {description ? (
        <p className="max-w-sm text-xs text-content-secondary">{description}</p>
      ) : null}
      {action ? (
        <Button className="mt-2" onClick={action.onClick}>
          {action.label}
        </Button>
      ) : null}
      {children}
    </div>
  )
}
